/** 路由鉴权守卫 — 未登录重定向 /login；有 token 但未加载用户信息时先拉取 */

import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAppContext } from '@/contexts/AppContext';
import LoadingSkeleton from '@/components/common/LoadingSkeleton';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { token, permissions, fetchUserInfo } = useAppContext();
  const [checking, setChecking] = useState<boolean>(() => !!token && permissions.length === 0);

  useEffect(() => {
    if (token && permissions.length === 0) {
      setChecking(true);
      fetchUserInfo()
        .catch(() => {
          // token 失效：清除并跳登录
          localStorage.removeItem('bluplanet_token');
        })
        .finally(() => setChecking(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (checking) {
    return <LoadingSkeleton />;
  }

  return <>{children}</>;
}
